module.exports = __webpack_public_path__ + "img/yalda_yes.f7696883.png";